/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable react/jsx-props-no-spreading */

import {
  IconBell, IconCalendar, IconMail, IconMenu2, IconPencil, IconStar,
} from "@tabler/icons-react";

import SwitchStatus, { Channel, Status } from "../../Switch/SwitchStatus/SwitchStatus";
import Tag, { TagColor } from "../../Tag/Tag";

interface HeaderProps {
  status: Status;
  statusLabel: string;
  writtenCount?: number;
  messagesCount?: number;
  ratingsCount?: number;
  notificationsCount?: number;
  availableChannels?: Channel[];
}

const headerStyle = `
  flex justify-between bg-bg-subtle border-b-2 items-center
  w-[374px] px-3 py-1
  md:w-[768px] md:px-3 md:py-1
  lg:w-[1030px] lg:px-3 lg:py-2.5
`;

const iconStyle = `
  p-2.5 bg-button-transparent-base text-icon-bg-subtle border border-border-transparent rounded-md
`;

const borderColors: Record<Status, string> = {
  offline: "border-switch-status-bg-offline",
  working: "border-switch-status-bg-working",
  online: "border-switch-status-bg-online",
  break: "border-switch-status-bg-break",
};

const Header = ({
  status, statusLabel, writtenCount = 0, messagesCount = 0, ratingsCount = 0, notificationsCount = 0, availableChannels = [],
}: HeaderProps) => {
  const menuIcons = [
    { icon: <IconPencil />, count: writtenCount },
    { icon: <IconMail />, count: messagesCount },
    { icon: <IconStar />, count: ratingsCount },
    { icon: <IconBell />, count: notificationsCount },
  ];
  return (
    <div className={`${headerStyle} ${borderColors[status]}`}>
      <div className="flex space-x-1">
        <div className={`lg:hidden ${iconStyle}`}>
          <button type="button"><IconMenu2 /></button>
        </div>
        <span className="lg:hidden w-px rounded-xs bg-border-base" />
        <div className={`lg:hidden ${iconStyle}`}>
          <button type="button"><IconCalendar /></button>
        </div>
        {menuIcons.map(({ icon, count }, index) => (
          <div key={index} className={iconStyle}>
            <button type="button">{count ? <Tag value={count} color={TagColor.pink}>{icon}</Tag> : icon}</button>
          </div>
        ))}
      </div>
      <SwitchStatus status={status} availableChannels={availableChannels} switchProps={{ label: statusLabel }} />
    </div>
  );
};

export default Header;
